import React from 'react';
import { shape, string, array, object, bool } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { BI_CONSTS } from '@fiverr-private/listing_lib';
import { Container } from '@fiverr-private/layout_components';
import { AggregatedRating } from '@fiverr-private/seo_content';
import { Breadcrumb, BreadcrumbsLink, BreadcrumbsHomeIcon } from '@fiverr-private/navigation';
import { createSourceInfo } from '../../../../../shared/utils/bi';
import ExplanationVideo from '../../../../../shared/components/Video/ExplanationVideo';
import { VIDEO_PROP_TYPES } from '../../../../../shared/components/Video/constants';

import './index.scss';

const SubcatHeader = ({ data, breadcrumbs, aggregatedRatingData, shouldShowRating }) => {
    const { isTouch } = getContext();
    const { title, video, showHowFiverrWorks } = data;

    const sourceInfo = createSourceInfo({
        videoName: video.name,
        mixpanelPageName: BI_CONSTS.MIXPANEL_PAGE_NAME,
        bigQueryPageName: BI_CONSTS.BIGQUERY_PAGE_NAME,
    });

    const [home, ...steps] = breadcrumbs || [];

    const showAggregatedRating = shouldShowRating && aggregatedRatingData;

    return (
        <Container as="header" className="subcategory-header" flexGrow={showAggregatedRating ? '1' : undefined}>
            <div className="title-wrapper">
                <div className="flex flex-col title-wrapper-col">
                    {breadcrumbs && (
                        <Breadcrumb>
                            <BreadcrumbsLink href={home.url}>
                                <BreadcrumbsHomeIcon />
                            </BreadcrumbsLink>
                            {steps.slice(0, -1).map((breadcrumb) => (
                                <BreadcrumbsLink key={breadcrumb.url} href={breadcrumb.url}>
                                    {breadcrumb.title}
                                </BreadcrumbsLink>
                            ))}
                        </Breadcrumb>
                    )}
                    <h1>{title}</h1>
                    <ExplanationVideo
                        subcat={data}
                        showButton={showHowFiverrWorks}
                        video={video}
                        videoTitle={<I18n k={video.titleKey} />}
                        sourceInfo={sourceInfo}
                        subTitleTag="h2"
                    />
                </div>
            </div>
            {showAggregatedRating && (
                <Container marginTop="6" marginBottom={isTouch ? '0' : '6'}>
                    <AggregatedRating aggregatedRating={aggregatedRatingData} />
                </Container>
            )}
        </Container>
    );
};

SubcatHeader.propTypes = {
    breadcrumbs: array,
    data: shape({
        title: string,
        subtitle: string,
        video: VIDEO_PROP_TYPES.video,
    }),
    aggregatedRatingData: object,
    shouldShowRating: bool,
};

export default SubcatHeader;
